import { ViewerModule } from '@g.frame/core';
import { Group, Object3D, } from 'three';
export default class ModularPopUp extends ViewerModule {
    constructor() {
        super();
        this.uiObject.name = 'ModularPopUp';
    }
    set(newOptions) {
        if (newOptions) {
            this.oldOptions = this.options;
            this.options = newOptions;
        }
        if (this.oldOptions) {
            this.oldOptions.background && this.disposeObject(this.oldOptions.background);
            this.oldOptions.elements.forEach(el => {
                this.disposeObject(el.object);
            });
        }
        this.mainContainer = new Group();
        this.options.elements.forEach(module => {
            if ((module.object instanceof ViewerModule) && module.object.uiObject) {
                module.object.uiObject.position.y = -module.margin;
                this.mainContainer.add(module.object.uiObject);
            }
            else if (module.object instanceof Object3D) {
                module.object.position.y = -module.margin;
                this.mainContainer.add(module.object);
            }
        });
        this.mainContainer.add(this.options.background.uiObject);
        this.options.background.uiObject.position.z = -0.0025;
        this.options.background.uiObject.position.y = -this.options.background.options.size.y / 2;
        this.addObject(this.mainContainer);
    }
}
